import React,{Component} from 'react'

import _ from 'lodash'

import {
  Hidden,
} from 'material-ui'

import Fade from 'material-ui/transitions/Fade'

import {LineChart, Line, XAxis, YAxis, Tooltip, Legend} from 'recharts'

import UnauthorizedText from './UnauthorizedText'

import {
  Accent,
  Primary,
  Purple,
  Green,
  LightGray,
} from '../helper/consts'

// const data = [
//       {name: 'Page A', uv: 4000, pv: 2400, amt: 2400},
//       {name: 'Page B', uv: 3000, pv: 1398, amt: 2210},
//       {name: 'Page C', uv: 2000, pv: 9800, amt: 2290},
//       {name: 'Page D', uv: 2780, pv: 3908, amt: 2000},
//       {name: 'Page E', uv: 1890, pv: 4800, amt: 2181},
//       {name: 'Page F', uv: 2390, pv: 3800, amt: 2500},
//       {name: 'Page G', uv: 3490, pv: 4300, amt: 2100},
// ];

const colors = [Primary,Accent,Purple,Green,LightGray,]

export default class DashboardUserActivityLineChart extends Component{
  render(){
    const {data} = this.props;
    return(
      !!data ?
        <Fade in={true} >
          <div>
            <Hidden mdDown>
              <LineChart width={900} height={500} data={data} >
                <XAxis interval={7}  padding={{left: 30, right: 30}} dataKey="name" height={60} />
                <YAxis allowDecimals={false} domain={[0, 'dataMax + 1']} />
                <Tooltip/>
                <Legend />
                {_.uniq(_.flatten(data.map(date=>{ return Object.keys(date) }))).filter(name=>{ return name!=='name'}).map((name,i)=>{
                  return <Line dot={false} key={`${name}_line`} type="monotone" dataKey={name} stroke={colors[i]} />
                })}
              </LineChart>
            </Hidden>
            <Hidden only={['xs','lg','xl']}>
              <LineChart width={570} height={350} data={data} >
                <XAxis interval={7}  padding={{left: 30, right: 30}} dataKey="name" height={60} />
                <YAxis allowDecimals={false} domain={[0, 'dataMax + 1']} />
                <Tooltip/>
                <Legend />
                {_.uniq(_.flatten(data.map(date=>{ return Object.keys(date) }))).filter(name=>{ return name!=='name'}).map((name,i)=>{
                  return <Line dot={false} key={`${name}_line`} type="monotone" dataKey={name} stroke={colors[i]} />
                })}
              </LineChart>
            </Hidden>
            <Hidden smUp>
              <LineChart width={300} height={200} data={data} >
                <XAxis interval={7}  padding={{left: 30, right: 30}} dataKey="name" height={60} />
                <YAxis allowDecimals={false} domain={[0, 'dataMax + 1']} />
                <Tooltip/>
                <Legend />
                {_.uniq(_.flatten(data.map(date=>{ return Object.keys(date) }))).filter(name=>{ return name!=='name'}).map((name,i)=>{
                  return <Line dot={false} key={`${name}_line`} type="monotone" dataKey={name} stroke={colors[i]} />
                })}
              </LineChart>
            </Hidden>
          </div>
        </Fade>
      :
        <div className="noData">
          <UnauthorizedText subText='Not Enough Data' />
        </div>
    )
  }
}
// <Hidden smUp>
//   <BarChart
//     width={288}
//     height={200}
//     data={data}
//   >
//     <XAxis interval={7}  dataKey="job"/>
//     <YAxis allowDecimals={false} domain={[0, 'dataMax + 1']} />
//     <Tooltip />
//     <Legend />
//     <Bar stackId="a" dataKey="Last Month" fill={Primary} />
//     <Bar stackId="a" dataKey="Last Week" fill={Accent} />
//     <Bar stackId="a" dataKey="Last Day" fill={Purple} />
//   </BarChart>
// </Hidden>



// WEBPACK FOOTER //
// ./src/components/DashboardUserActivityLineChart.js